module.exports = __webpack_public_path__ + "img/airplane.405f09d.jpg";